import { useSelector } from 'react-redux';
import styled from 'styled-components';
import ReactDOMServer from 'react-dom/server';
import colors from '../../../../../../../constants/colors';
import Translator from '../../../../../../components/helpers/Translator';

export default function SaicaWeight(props) {
  const { plantObligationID } = props;
  const poLevel3 = useSelector(
    (state) => state.currentPage?.plantObligationLevels?.level3
  );

  return poLevel3[plantObligationID]?.multiplier ? (
    <WeightTag
      className="mx-1"
      title={ReactDOMServer.renderToString(
        <Translator
          file="module-legalCompliance"
          name="weight.value"
          variables={{
            value: poLevel3[plantObligationID]?.multiplier,
          }}
        />
      )}
    >
      {poLevel3[plantObligationID]?.multiplier}
    </WeightTag>
  ) : null;
}

const WeightTag = styled.span`
  color: ${colors.primaryLight};
  cursor: default;
`;
